<template>
  <div class="cmp-elastic-product-details utlz-reset utlz-row">
      <div class="utlz-col-md-4 column-left">
        <utlz-gallery :product="productDetails" :useThumbnails="true"></utlz-gallery>
      </div>
      <div class="utlz-col-md-8 column-right product-details-column">
          
          <template v-if="hoveredOnTabs">
            <div id="blocker" @click="setHoverOnTabs(false)">

            </div>
          </template>

          <div class="product-information" :class="{'hovered-on-tabs': hoveredOnTabs}">
            <template v-if="hoveredOnTabs">
              <div class="close-btn-wr">                
                <button class="close-btn tab-btn" @click="setHoverOnTabs(false)">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </template>
            
            
             <!-- BESPOKE HWS: Set prod code above prod title  -->
            <div class="product-code">
              <template v-if="!isMainMatrixProduct">
                <span class="code-label" v-translation="{type: 'label', code: 'label_product_code' }"></span>
              </template>
              <template v-else>
                <span class="code-label" v-translation="{type: 'label', code: 'label_category_code' }"></span>
              </template>
                <span>{{ productDetails.id }}</span>
            </div>
            <!-- END BESPOKE HWS -->          

            <h1>{{productDetails.shortDescription}}</h1>

             <!-- BESPOKE ROD: Moved stock underneath title and only show if !isMainMatrixProduct -->
             <template v-if="!isMainMatrixProduct">
              <utlz-product-stock
                :product="productDetails"
                :stock="productDetails.stock"
                :stockTotal="productDetails.stock"
              ></utlz-product-stock>
            </template>
            <!-- END BESPOKE ROD -->

            <!-- BESPOKE ROD: Added  !isMainMatrixProduct-->
            <div class="ph-product-price" v-if="productDetails.prices.length && !isMainMatrixProduct">
                <utlz-product-price
                    :prices="productDetails.prices[0]"
                ></utlz-product-price>
            </div>            
            <!-- END BESPOKE ROD -->
            <div class="content-wr">
              <utlz-tabs :tabs="tabs">
                
                    <!-- BESPOKE -->
                    <template v-if="!hoveredOnTabs" v-slot:readmore>
                      <div class="btn-wrapper">
                        <a v-translation="{ type: 'label', code: 'label_tabs_read_more'}" @click="setHoverOnTabs(true)" class="btn-u read-more-btn"></a>
                      </div>
                    </template>
                    <!-- END BESPOKE -->

                <template v-slot:description>
                  <div class="prod-desc-long">                  

                    <div class="prod-desc-container">
                      <div ref="productDescription" class="prod-desc-wrapper">
                        <div class="product-long-description" v-html="productDetails.longDescription">
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </template>

                <template v-slot:matrixSizes>
                  <div v-html="matrixSizes"></div>
                </template>

                <template v-slot:videos v-if="videos.length">
                  <div class="product-videos">
                    <utlz-product-videos :videos="videos"></utlz-product-videos>
                  </div>
                </template>

                <template v-slot:documents v-if="documents.length">
                  <div class="product-documents">
                    <utlz-product-documents :documents="documents"></utlz-product-documents>
                  </div>
                </template>

                <!-- BESPOKE ROD: Grouped specification under a tab and disabled header -->
                <template v-slot:specs>
                  <div class="product-specifications">
                  <!-- <h2 v-translation="{ type: 'title', code: 'title_specifications' }"></h2> -->
                  <div class="spec-list">
                    <div class="spec-item" v-for="prop in sortedProductProperties" :key="prop.key" :class="{'is-ff-desc': prop.isFFDesc}">
                      
                      <div class="spec-desc">
                        {{prop.key}}
                      </div>
                      <div class="spec-value" v-if="containsHTML(prop.value)" v-html="prop.value"></div>
                      <div class="spec-value" v-else>{{ prop.value }}</div>

                    </div>
                  </div>
                </div>
                </template>

                <template v-slot:matrixDownloads>
                  <div class="mtrx-downloads" v-html="matrixDownloads"></div>
                </template>
                <!-- END BESPOKE ROD -->
              </utlz-tabs>
            </div>

            <utlz-group-dropdown :variants="productVariants" />            

            <div class="order-product">
              <utlz-order-product
                v-if="showOrderProductControl && productDetails.prices.length"
                :product="productDetails"
                :useOrderComment="useOrderLineComments"
                >
                </utlz-order-product>

                <transition name="fade">
                  <p v-if="!showOrderProductControl && showStock" class="out-of-stock-msg">
                    <i class="fa fa-warning"></i>
                    <span v-translation="{ type: 'label', code: 'label_out_of_stock' }"></span>
                  </p>
                </transition>
            </div>

            <!-- BESPOKE ROD: Disable favorites -->
            <!-- <div class="favorite">
              <utlz-favorites-control v-if="showFavorites" :product="productDetails" :useDescription="true"></utlz-favorites-control>
            </div> -->
            <!-- END BESPOKE ROD -->
          </div>
      </div>


      <div v-if="showOrderProductControl && productDetails.prices.length && productVariants.length" class="utlz-col-md-12">
        <utlz-group-matrix :variants="productVariants" />
      </div>

      <div v-if="relatedProducts.upSelling.length" class="related-products upselling utlz-col-12 ">
        <utlz-product-carousel
          :products="relatedProducts.upSelling"
          :blockSize="relatedProductBlockSize"
          :title="titleUpSelling"
        ></utlz-product-carousel>
      </div>

      <div v-if="relatedProducts.crossSelling.length" class="related-products upselling utlz-col-12 ">
        <utlz-product-carousel
          :products="relatedProducts.crossSelling"
          :blockSize="relatedProductBlockSize"
          :title="titleCrossSelling"
        ></utlz-product-carousel>
      </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import OrderProduct from 'src/components/webshop/order-product/OrderProduct.vue';
import ProductStock from 'src/components/webshop/product-stock/ProductStock.vue';
import ProductGroupMatrix from 'src/components/webshop/products/product-group/ProductGroupMatrix.vue';
import ProductGroupDropdown from 'src/components/webshop/products/product-group/ProductGroupDropdowns.vue';
import FavoritesControl from 'src/components/webshop/favorites/FavoritesControl.vue';
import Gallery from 'src/components/ui/gallery/Gallery.vue';
import Tabs from 'src/components/ui/tabs/Tabs.vue';
import ProductVideos from 'src/components/webshop/products/product-videos/ProductVideos.vue';
import ProductDocuments from 'src/components/webshop/products/product-documents/ProductDocuments.vue';
import ProductCarousel from 'src/components/webshop/products/product-carousel/ProductCarousel.vue';
export default {
  components: {
    'utlz-product-price': ProductPrice,
    'utlz-order-product': OrderProduct,
    'utlz-product-stock': ProductStock,
    'utlz-group-matrix': ProductGroupMatrix,
    'utlz-group-dropdown': ProductGroupDropdown,
    'utlz-favorites-control': FavoritesControl,
    'utlz-gallery': Gallery,
    'utlz-tabs': Tabs,
    'utlz-product-carousel': ProductCarousel,
    'utlz-product-videos': ProductVideos,
    'utlz-product-documents': ProductDocuments
  },
  data () {
    return {
      hoveredOnTabs: false,
      expanded: false,
      productDescriptionHeight: 0,
      titleUpSelling: window.vue.translations.title.title_product_relations,
      titleCrossSelling: window.vue.translations.title.title_product_relations_cross,
      tabs: [
        { id: 'description', description: window.vue.translations.label.label_tab_product_desc, active: false, visible: false },
        { id: 'matrixSizes', description: window.vue.translations.label.label_tab_measurements, active: false, visible: false },
        { id: 'documents', description: window.vue.translations.label.label_tab_product_documents, active: false, visible: false },
        { id: 'videos', description: window.vue.translations.label.label_tab_product_videos, active: false, visible: false },
        // BESPOKE ROD
        // Added product specs as tab
        { id: 'specs', description: window.vue.translations.title.title_specifications, active: false, visible: false },
        { id: 'matrixDownloads', description: window.vue.translations.label.label_mtrx_downloads, active: false, visible: false }
        // END BESPOKE ROD
      ]
    }
  },
  watch: {
    longDescription (val) { this.tabs[0].visible = val.length > 0 },
    documents (val) { this.tabs[2].visible = false }, // BESPOKE Hide documents, as we provide downloads html editor
    videos (val) { this.tabs[3].visible = val.length > 0; },
    productProperties (val) { this.tabs[4].visible = val.length > 0; },
    matrixDownloads (val) { this.tabs[5].visible = val.length > 0; }
  },
  computed: {
    // BESPOKE ROD
    // Added isMainMatrixProduct
    ...mapState('elastic', ['matrixSizes', 'matrixDownloads']),
    ...mapState('productDetails', ['productDetails', 'productVariants', 'relatedProducts', 'videos', 'isMainMatrixProduct']),
    ...mapGetters(['showStock', 'showPrices', 'showFavorites', 'showOrderProduct', 'stockLimit', 'useOrderLineComments', 'relatedProductBlockSize', 'language']),
    ...mapGetters('productDetails', ['documents']),
    // BESPOKE ROD
    longDescription() {
      return this.productDetails.longDescription;
    },
    sortedProductProperties() {
      return [...this.productProperties].sort((a, b) =>
        a.key.localeCompare(b.key)
      );
    },
    // END BESPOKE ROD
    useCollapse () {
      return this.productDescriptionHeight > 150;
    },
    showOrderProductControl () {
      if (!this.showPrices) {
        return false;
      } else if (this.showOrderProduct) {
        if (!this.stockLimit) {
          return true;
        } else if (this.stockLimit && this.productDetails.stock !== null) {
          return this.stockLimit && this.productDetails.stock.stockTotal > 0;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // BESPOKE
    productProperties () {
      var language = this.language.toUpperCase();

      var labels = window.vue.translations.label;

      var ffDescLabels = {
        ['FF_DESC1_' + language]:  { label: labels.label_free_text1, value: ''},
        ['FF_DESC2_' + language]: { label: labels.label_free_text2, value: ''},
        ['FF_DESC3_' + language]: { label: labels.label_free_text3, value: ''},
        ['FF_DESC4_' + language]: { label: labels.label_free_text4, value: ''},
        ['FF_DESC255_' + language]: { label: labels.label_free_text255, value: ''}
      };

      // If a key is used twice, combine the property values for that key and seperate with a |
      var properties = [];
      Object.keys(this.productDetails.properties).forEach(x => {

        var existingProperty = properties.find(y => y.key.trim() === x.trim());        
        if (existingProperty !== undefined) {
          existingProperty.value = existingProperty.value + " | " + this.productDetails.properties[x];
        } else {
          properties.push({ key: x, value: this.productDetails.properties[x], isFFDesc: false });
        }

      });

      // Add ff_desc custom strings to the specifications
      var customStingsObj = this.productDetails.customStrings;
        
      if (customStingsObj != undefined && customStingsObj != null) {

        var customStringKeys = Object.keys(customStingsObj);
        customStringKeys.forEach(customStringKey => {
          if (ffDescLabels.hasOwnProperty(customStringKey)) {
            // ff_desc_labels has the property
            ffDescLabels[customStringKey].value = customStingsObj[customStringKey];
            properties.push({ key: ffDescLabels[customStringKey].label, value: customStingsObj[customStringKey], isFFDesc: true });
          }
        });
      }

      
      // Check if in the properties object there is the cutoff PIM value, in which case we updat the value with the value from the CustomStrings Object
      // properties.forEach(propKeyValuePair => {
      //   Object.keys(ffDescLabels).forEach(ffDescLabelKey => {
      //       var keyValue = ffDescLabels[ffDescLabelKey].label;        
      //       if (propKeyValuePair.key == keyValue) {
      //         propKeyValuePair.value = ffDescLabels[ffDescLabelKey].value;
      //       }             
      //   });        
      // });

      // Then check for remaining customStrings not found in the Properties object and update the Properties obhect with those
      // var propertiesKeys = properties.map(x => x.key);
      
      // Object.keys(ffDescLabels).forEach(ffDescLabelKey => {
      //   if (propertiesKeys.indexOf(ffDescLabels[ffDescLabelKey].label) < 0) {
      //     if (ffDescLabels[ffDescLabelKey].value !== '') {
      //       properties.push({key: ffDescLabels[ffDescLabelKey].label, value: ffDescLabels[ffDescLabelKey].value })
      //     }
      //   }
      // });
      
      return properties;
      // END BESPOKE CAP
    },
    images () {
      let images = [];

      images.push(this.productDetails.imageUrl)

      this.productDetails.images.forEach(element => {
        images.push(element);
      });

      return images
    }
  },
  updated () {
    if (this.$refs.productDescription !== undefined) {
      this.productDescriptionHeight = this.$refs.productDescription.clientHeight;
    }

    // BESPOKE
    this.tabs[1].visible = this.matrixSizes.length > 0;
    this.tabs[5].visible = this.matrixDownloads.length > 0;
    // END BESPOKE
  },
  created () {
    this.initDetails();
  },
  methods: {
    ...mapActions('productDetails', ['initDetails']),
    // BESPOKE
    setHoverOnTabs(state) {
      this.hoveredOnTabs = state;
      if (state) {
        $('body').addClass('disable-scroll')
      } else {
        $('body').removeClass('disable-scroll');
      }
    },
    containsHTML(str) {
      const htmlRegex = /<\/?[a-z][\s\S]*>/i;
      return htmlRegex.test(str);
    }
    // END BESPOKE
  }
}
</script>

<style>

</style>
